import { PermissionGate } from '@urbanik/ui';
import { useAccess } from './AccessBoundary';
import './access.css';

export function AccessComparisonView() {
  const access = useAccess();
  const isAdministrator = access.roles.includes('administrator');
  return (
    <div className="shell-page access-page">
      <header className="page-heading">
        <div>
          <p className="kicker">M02.5 · Permisos UI</p>
          <h1>Acceso según el perfil.</h1>
          <p>
            La interfaz responde a los permisos efectivos de la sesión sin sustituir al servidor.
          </p>
        </div>
        <span className="surface-badge">{isAdministrator ? 'Administrador' : 'Restringido'}</span>
      </header>
      <section className="access-profile" aria-labelledby="access-profile-title">
        <div>
          <p className="kicker">Sesión verificada</p>
          <h2 id="access-profile-title">{access.principal.displayName}</h2>
          <p>{access.principal.email}</p>
        </div>
        <dl>
          <div>
            <dt>Roles</dt>
            <dd>{access.roles.join(', ') || 'Sin rol'}</dd>
          </div>
          <div>
            <dt>Permisos</dt>
            <dd>{access.permissions.length}</dd>
          </div>
        </dl>
      </section>
      <section className="access-comparison" aria-labelledby="comparison-title">
        <div className="section-title">
          <p className="kicker">Comparación efectiva</p>
          <h2 id="comparison-title">Acciones protegidas</h2>
        </div>
        <div className="access-comparison__grid">
          <article>
            <strong>Lista de roles</strong>
            <p>
              Requiere <code>identity.roles.read</code>.
            </p>
            <PermissionGate
              permission="identity.roles.read"
              permissions={access.permissions}
              fallback={
                <span className="access-denied" role="status">
                  No disponible para este perfil
                </span>
              }
            >
              <a className="ui-button ui-button--primary" href="#roles">
                Abrir roles
              </a>
            </PermissionGate>
          </article>
          <article>
            <strong>Matriz de permisos</strong>
            <p>
              Requiere <code>identity.permissions.read</code>.
            </p>
            <PermissionGate
              permission="identity.permissions.read"
              permissions={access.permissions}
              fallback={
                <span className="access-denied" role="status">
                  No disponible para este perfil
                </span>
              }
            >
              <a className="ui-button ui-button--primary" href="#permisos">
                Abrir matriz
              </a>
            </PermissionGate>
          </article>
        </div>
      </section>
    </div>
  );
}
